var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{attrs:{"data-align":"center","data-column-id":"mnu","data-formatter":"mnu","data-sortable":"false","data-width":"36px","title":"Menu de opções","data-header-no-icon":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }